<!--  -->

<template>
  <div class="content">
    <div class="ban">
      <img @click="jump" src="../../assets/img/storage/banner.png" alt="" />
    </div>
    <!-- 仓库系统 -->
    <div class="introduces">
      <div class="card flex">
        <div class="left">
          <img src="../../assets/img/storage/img.png" alt="" />
        </div>
        <div class="right">
          <div class="all_text">
            <img src="../../assets/img/index/ico.png" alt="" />
            <div class="text">
              仓库管理系统<br />
              简介
            </div>
            <div class="row"></div>
          </div>
          <!-- 文案 -->
          <div class="some_info">
            <div class="text">
              系统涵盖仓储出入库管理和仓储配送管理两大模块，为企业提供仓储配送一体化全流程管理解决方案。
            </div>
            <br />
            <div class="text padding_top" style="text-align: justify;">
              实现仓库全面的数据化和信息化管理，实时掌握仓库的运输跟踪动态信息。对商品存储和出入库进行动态安排，对仓库作业流程的动态管控，优化货架布局，提高作业效率。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 特点 -->
    <div class="characteristic">
      <Link text="仓储配送一体化特点" />
      <div class="img">
        <img src="../../assets/img/storage/bg.png" alt="" />
      </div>
      <div class="list card">
        <div class="li" v-for="(item, index) in td_list" :key="index">
          <img :src="item.img" alt="" />
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 介绍 -->
    <div class="introduce">
      <Link text="系统主要功能简介" />
      <div class="list card">
        <div class="li" v-for="(item, index) in js_list" :key='index'>
          <img :src="item.img" alt="">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="text">
            {{ item.text }}

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      td_list: [
        {
          title: "智能分析订单类型",
          text: "不同订单类型指定不同拣货方式，并且提供对应的便捷出库运输流程。",
          img: require("../../assets/img/storage/1.png"),
        },
        {
          title: "货品细化管理",
          text: "支持多码管理，支持优良品、残次品区分管理，支持批次、有效期明细管理。",
          img: require("../../assets/img/storage/2.png"),
        },
        {
          title: "支持通过PDA设备进行无纸化操作",
          text: "入库开单、入库移位、销售拣货、销售复核、盘点、理库、库存查询。",
          img: require("../../assets/img/storage/3.png"),
        },
        {
          title: "智能仓库管理",
          text: "支持仓库的集中或分布式部署，无论仓库在何处都可以精准的进行任务分配。",
          img: require("../../assets/img/storage/4.png"),
        },
        {
          title: "业务防呆机制",
          text: "对仓库内业务的进程进行记录和监控，进行业务防呆优化，提高仓储运作效率。",
          img: require("../../assets/img/storage/5.png"),
        },
        {
          title: "可自选搭配的出入库环节控制",
          text: "丰富的出入库环节控制可供用户选择，可自己定制更贴近仓储特色的出入库方式，灵活控制进出业务。",
          img: require("../../assets/img/storage/6.png"),
        },
        {
          title: "全流程动态监管",
          text: "订单管理、库存分析；仓库收发货实时跟踪、日/月/周数据便捷查询。",
          img: require("../../assets/img/storage/7.png"),
        },
        {
          title: "采购、仓储、发货三合一",
          text: "产品买卖，一目了然；库存明细，一周掌握；发货管理，及时清晰。",
          img: require("../../assets/img/storage/8.png"),
        },
        {
          title: "多层次仓库管理",
          text: "支持多货主管理、多仓库管理，多个维度立体划分仓库进行管理。",
          img: require("../../assets/img/storage/9.png"),
        },
        {
          title: "自主预约提货",
          text: "协助运输公司实现自主预约提货，将原有的线下沟通预约方式转变为线上进行，从而提升预约效率。",
          img: require("../../assets/img/storage/10.png"),
        },
      ],
      js_list: [
        {
          title: "物料档案",
          text: "可通过批量导入或手动添加物料信息，实现对物料扫描条码、换算规格等基础信息，进行电子信息化管理。",
          img: require("../../assets/img/storage/ico1.png"),
        },
        {
          title: "货物管理",
          text: "对仓库货位进行系统化管理，并对货位容量进行预警提示，实时监控货位容量信息。",
          img: require("../../assets/img/storage/ico2.png"),
        },
        {
          title: "实收入库",
          text: "实现电脑端与手持端（PC端+PDA端）同步入库，两端信息实时共享，确保入库信息准确无误，提升仓库入库操作效率和准确率。",
          img: require("../../assets/img/storage/ico3.png"),
        },
        {
          title: "出库管理",
          text: "通过PDA手持端进行货物的拣配、复核实现电脑端与PDA端操作无缝衔接，定单数据实时同步；降低货物出库差错、提升出库时效。",
          img: require("../../assets/img/storage/ico4.png"),
        },
        {
          title: "库存查询",
          text: "查询货物实时库存，了解货物出入库数据，掌握最新的货物货位库存信息。",
          img: require("../../assets/img/storage/ico5.png"),
        },
        {
          title: "数据分析",
          text: "通过货物出入库数据，实现对货物批次的效期、滞销情况和销量等数据进行统计和分析，一键导出分析数据，为仓库管理提供数据分析依据。",
          img: require("../../assets/img/storage/ico6.png"),
        },
        {
          title: "外发录入",
          text: "对出库定单进行系统列运，可一次批量列运多个出库定单，自动核算运输费用，记录定单物流运输配送信息。",
          img: require("../../assets/img/storage/ico7.png"),
        },
        {
          title: "回单上传",
          text: "对出库定单进行系统列运，可一次批量列运多个出库定单，自动核算运输费用，记录定单物流运输配送信息。",
          img: require("../../assets/img/storage/ico8.png"),
        },
        {
          title: "外发跟踪",
          text: "查询和记录客服人员对定单运输配送过程中的跟踪和回访信息。",
          img: require("../../assets/img/storage/ico9.png"),
        }
      ],
     

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang='less'>
@import url(../storage/pc);


</style>